const GET_SCANNED_DOCUMENT_REQUEST = 'GET_SCANNED_DOCUMENT_REQUEST';
const GET_SCANNED_DOCUMENT_SUCCESS = 'GET_SCANNED_DOCUMENT_SUCCESS';
const GET_SCANNED_DOCUMENT_ERROR = 'GET_SCANNED_DOCUMENT_ERROR';

const CREATE_SCANNED_DOCUMENT_REQUEST = 'CREATE_SCANNED_DOCUMENT_REQUEST';
const CREATE_SCANNED_DOCUMENT_SUCCESS = 'CREATE_SCANNED_DOCUMENT_SUCCESS';
const CREATE_SCANNED_DOCUMENT_ERROR = 'CREATE_SCANNED_DOCUMENT_ERROR';

const DELETE_SCANNED_DOCUMENT_REQUEST = 'DELETE_SCANNED_DOCUMENT_REQUEST';
const DELETE_SCANNED_DOCUMENT_SUCCESS = 'DELETE_SCANNED_DOCUMENT_SUCCESS';
const DELETE_SCANNED_DOCUMENT_ERROR = 'DELETE_SCANNED_DOCUMENT_ERROR';

const CLEAR_SCANNED_DOCUMENTS_STATE = 'CLEAR_SCANNED_DOCUMENTS_STATE';
const CLEAR_ERRORS = 'CLEAR_ERRORS';
const CLEAR_ERRORS_PROFILE = 'CLEAR_ERRORS_PROFILE';
const INIT_REDUCER = 'INIT_REDUCER';

const UPDATE_SCANNED_DOCUMENT_REQUEST = 'UPDATE_SCANNED_DOCUMENT_REQUEST';
const UPDATE_SCANNED_DOCUMENT_SUCCESS = 'UPDATE_SCANNED_DOCUMENT_SUCCESS';
const UPDATE_SCANNED_DOCUMENT_ERROR = 'UPDATE_SCANNED_DOCUMENT_ERROR';
const CREATE_ERRORS = 'CREATE_ERRORS';

export {
  GET_SCANNED_DOCUMENT_REQUEST,
  GET_SCANNED_DOCUMENT_SUCCESS,
  GET_SCANNED_DOCUMENT_ERROR,
  CREATE_SCANNED_DOCUMENT_REQUEST,
  CREATE_SCANNED_DOCUMENT_SUCCESS,
  CREATE_SCANNED_DOCUMENT_ERROR,
  DELETE_SCANNED_DOCUMENT_REQUEST,
  DELETE_SCANNED_DOCUMENT_SUCCESS,
  DELETE_SCANNED_DOCUMENT_ERROR,
  CLEAR_SCANNED_DOCUMENTS_STATE,
  CLEAR_ERRORS,
  CLEAR_ERRORS_PROFILE,
  UPDATE_SCANNED_DOCUMENT_REQUEST,
  UPDATE_SCANNED_DOCUMENT_SUCCESS,
  UPDATE_SCANNED_DOCUMENT_ERROR,
  CREATE_ERRORS,
  INIT_REDUCER,
};
